
import React from 'react';
import { Input } from 'components/ui';
import { DebouncedFunction } from 'debounce';
import { FormattedMessage } from 'react-intl';
import { QR_CODE_LENGTH } from 'modules/auth/constants';

type QrCodeFormProps = {
  value?:string;
  disabled?: boolean;
  className?: string;
  error?: React.ReactNode;
  message: React.ReactNode;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleOnKeyDown: DebouncedFunction<(event: React.KeyboardEvent<HTMLInputElement>) => void>
};

const QrCodeForm: React.FC<QrCodeFormProps> = ({ disabled = false, handleOnChange, handleOnKeyDown, error, value, message, className }) => (
  <div className={className}>
    <div className="text-center">
      {message}
    </div>
    <Input
      center
      value={value}
      error={error}
      type="password"
      inputMode="numeric"
      disabled={disabled}
      onChange={handleOnChange}
      maxLength={QR_CODE_LENGTH}
      onKeyDown={handleOnKeyDown}
      className="mt-4 text-center"
      label={<FormattedMessage id="login.code.label" defaultMessage="Code"/>}
    />
  </div>
);
;

export default QrCodeForm;
